import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ComercialProductResponseDTO, CommonDataDTO } from '@app/requests/model/combos-model';
import {
  CommercialProductRequestDTO,
  CustomerInterestResponse,
  TariffRequestDTO,
  TariffSectorResponseDTO,
  TariffSheetRequest,
  TariffSheetCommon,
  TariffTradeDiscountResponse,
  TariffVersionDTO,
  TradeDiscountDTO,
  TariffSheetResponseDTO,
} from '../model/tariffs-model';
import { TariffsApi } from './tariffs.service';

@Injectable()
export class TariffsStore {
  private headersLeasing = [
    'tariffs.leasing.expenses.financed',
    'tariffs.leasing.inc',
    'tariffs.leasing.expenses.not.financed',
    'tariffs.leasing.inc',
    'tariffs.leasing.fee',
  ];

  private headersIrregularQuotas = [
    'tariffs.irregular.lifePayment',
    'tariffs.irregular.coef.first',
    'tariffs.irregular.coef.second',
    'tariffs.irregular.coef.remaining',
    'tariffs.irregular.inc',
    ' ',
    'tariffs.irregular.life',
    'tariffs.irregular.coef.first',
    'tariffs.irregular.coef.second',
    'tariffs.irregular.coef.remaining',
    'tariffs.irregular.inc',
    ' ',
    ' ',
    'tariffs.irregular.coef.first',
    'tariffs.irregular.coef.second',
    'tariffs.irregular.coef.remaining',
    'tariffs.irregular.inc',
    'tariffs.irregular.fee',
  ];

  private headersCiCo = [
    'tariffs.cico.lifePayment',
    'tariffs.cico.Inc',
    'tariffs.cico.life',
    'tariffs.cico.Inc',
    ' ',
    ' ',
    'tariffs.cico.noProtection',
    'tariffs.cico.Inc',
    'tariffs.cico.fee',
  ];

  constructor(private tariffsApi: TariffsApi) {}

  public getHeadersLeasing() {
    return this.headersLeasing;
  }

  public getHeadersIrregularQuotas() {
    return this.headersIrregularQuotas;
  }

  public getHeadersCiCo() {
    return this.headersCiCo;
  }

  loadCommercialProductByFilter(request: CommercialProductRequestDTO) {
    return new Promise<ComercialProductResponseDTO[]>((resolve, reject) => {
      this.tariffsApi.getCommercialProductByFilter(request).subscribe(
        (data) => (data ? resolve(data) : reject(data)),
        (error) => reject(error)
      );
    });
  }

  loadSectorByEstablishment(establishment: string) {
    return new Promise<TariffSectorResponseDTO[]>((resolve, reject) => {
      this.tariffsApi.getSectorByEstablishment(establishment).subscribe(
        (data) => (data ? resolve(data) : reject(data)),
        (error) => reject(error)
      );
    });
  }

  loadTariffsByFilter(form: FormGroup) {
    const tariffRequestDTO: TariffRequestDTO = {
      establishment: form.controls.establishment?.value,
      commercialProduct: form.controls.commercialProduct?.value,
      sector: form.controls.sector?.value,
      tariff: form.controls.tariff?.value,
    };
    return new Promise<TariffVersionDTO[]>((resolve, reject) => {
      this.tariffsApi.getTariffsByFilter(tariffRequestDTO).subscribe(
        (data) => (data ? resolve(data) : reject(data)),
        (error) => reject(error)
      );
    });
  }

  getTariffSheetTable(request: TariffSheetRequest) {
    return new Promise<TariffSheetResponseDTO>((resolve, reject) => {
      this.tariffsApi.getTariffSheetTable(request).subscribe(
        (data) => (data ? resolve(data) : reject(data)),
        (error) => reject(error)
      );
    });
  }

  getTradeDiscount(request: TradeDiscountDTO): Promise<TariffTradeDiscountResponse> {
    return new Promise<TariffTradeDiscountResponse>((resolve, reject) => {
      this.tariffsApi.getTradeDiscount(request).subscribe(
        (data) => (data ? resolve(data) : reject(data)),
        (error) => reject(error)
      );
    });
  }

  loadInterestCommercialProduct(establishmentId: string) {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      this.tariffsApi.getInterestCommercialProduct(establishmentId).subscribe(
        (data) => (data ? resolve(data) : reject(data)),
        (error) => reject(error)
      );
    });
  }

  getCommercialInterest(request: TariffSheetRequest) {
    return new Promise<CustomerInterestResponse>((resolve, reject) => {
      this.tariffsApi.getTariffInterestCommercial(request).subscribe(
        (data) => (data ? resolve(data) : reject(data)),
        (error) => reject(error)
      );
    });
  }

  loadCicoCommercialProduct(establishment: string) {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      this.tariffsApi.getCicoCommercialProduct(establishment).subscribe(
        (data) => (data ? resolve(data) : reject(data)),
        (error) => reject(error)
      );
    });
  }
}
